import { Color } from '@kite-js/theme-types';

const red: Color = {
    50: '#f7d5d1',
    100: '#e78276',
    200: '#df5949',
    300: '#d72f1b',
    400: '#ca1212',
    500: '#b21010',
};

export default red;
